export default "__VITE_ASSET__BuYbo1UQ__"